<template>
  <div>
    <section>
      <div class="website-basket-padding border-bottom">
        {{ $resourceString["checkout.Project.Header"] }}
      </div>
    </section>

    <div>
      <!-- Salesforce Opportunities -->
      <pc-salesforce-opportunities :user-email="userEmail" class="sfOpps" @contact-found="handleContactFound"
        @update-project-name="setProjectName" />

      <!-- Project Name Field (hidden when an opportunity is found) -->
      <div v-if="!contactFound" class="mt-3 pb-1 d-flex flex-column">
        <label class="d-inline-block font-16 font-weight-bold mr-2">
          {{ $resourceString["checkout.Project.Title"] }}
        </label>
        <input v-model="projectName" @input="submitProjectName" placeholder="Project Name*"
          class="shipping-modal-input-field form-control col-lg-5 col-12" />
        <br />
        <span class="font-16 danger" v-if="getValidationErrorPName">
          {{ $resourceString["checkout.ProjectName.ValidationError"] }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import SalesforceOpportunities from "../checkout-page/pc-salesforce-opportunities.vue";

export default {
  props: {
    userEmail: String,
  },
  components: {
    "pc-salesforce-opportunities": SalesforceOpportunities,
  },
  data() {
    return {
      projectName: "",
      contactFound: false,
    };
  },
  computed: {
    ...mapGetters({
      getValidationErrorPName: "checkoutPage/getValidationErrorPName",
      checkoutData: "checkoutPage/checkoutData"
    })
  },
  methods: {
    ...mapActions({
      setProjectName: "checkoutPage/setProjectName" 
    }),
    handleContactFound(found) {
      this.contactFound = found;
    },
    submitProjectName() {
      if (this.projectName) {
        this.setProjectName(this.projectName);
      }
    }
  },
  watch: {
    checkoutData(newValue) {
      if (!this.projectName && this.checkoutData.ProjectName) {
        this.projectName = this.checkoutData.ProjectName;
      }
    }
  }
};
</script>
